import { ADMIN_ARTICEL_REQUEST_RESET } from "../../../redux/article/articlesConstants";
import { adminArticleDetailAction } from "../../../redux/article/articalsActions";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";
import Button from "@material-ui/core/Button";
import Snackbar from "@material-ui/core/Snackbar";
import Grid from "@material-ui/core/Grid";
import MuiAlert from "@material-ui/lab/Alert";
import { Field, Formik } from "formik";
import TextField from "@material-ui/core/TextField";
import * as yup from "yup";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { CircularProgress } from "@material-ui/core";
import CustomImageInput from "../../Form/CustomImageInput/Index";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import "../editor.css";

const useStyles = makeStyles((theme) => ({
    btn: {
        padding: theme.spacing(1.2),
        backgroundColor: "transparent",
        fontWeight: "700",
        maxWidth: "170px",
        borderRadius: "10px 10px 0px 0px",
        boxShadow: "none",
        "&:hover": {
            backgroundColor: "transparent",
            boxShadow: "none",
        },
        color: "#616161",
        border: "1px solid #D0D0D0",
        borderBottom: "none",
        width: "100%",
    },
    btnActive: {
        padding: theme.spacing(1.2),
        borderRadius: "10px 10px 0px 0px",
        maxWidth: "170px",
        backgroundColor: "#ffffff",
        fontWeight: "700",
        boxShadow: "none",
        "&:hover": {
            backgroundColor: "#ffffff",
            boxShadow: "none",
        },
        color: "#3B3B3B",
        width: "100%",
    },
    formControl: {
        margin: theme.spacing(1),
        width: "100%",
        backgroundColor: "#ffffff",
        borderRadius: "10px",
    },
    danger: {
        color: "red",
    },
    select: {
        borderRadius: "10px",
        width: "100%",
        height: "34px",
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
    input: {
        background: "#F5F5F5",
        border: "1px solid #A7A7A7",
        borderRadius: "10px",
        width: "99%",
        height: "40px",
        fontSize: "17px",
        "&:focus": {
            outline: " none !important",
        },
    },
    label: {
        lineHeight: "42px",
        fontSize: "15px",
        fontWeight: "normal",
    },
    mute: {
        color: "#808080",
    },
    textarea: {
        background: "#F5F5F5",
        border: "1px solid #A7A7A7",
        borderRadius: "10px",
        maxWidth: "98%",
        minWidth: "95%",
        padding: "10px",
        fontSize: "17px",
        "&:focus": {
            outline: " none !important",
        },
    },
    show: {
        display: "block",
    },
    hide: {
        display: "none",
    },
    cursor: {
        cursor: 'pointer'
    }
}));

let cat = [];

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

// const FILE_SIZE = 160 * 1024 * 160;

// const SUPPORTED_FORMATS = ["image/jpg", "image/jpeg", "image/gif", "image/png"];

const validationSchema = yup.object({
    CategoryId: yup
        .string("دسته بندی مقاله را وارد کنید.")
        .required("دسته بندی مقاله الزامی می باشد."),
    Title: yup
        .string("عنوان مقاله را وارد کنید.")
        .required("عنوان مقاله الزامی می باشد."),
    ShortDescription: yup.string().required("چکیده مقاله الزامی می باشد."),
    Image: yup.mixed(),
});

const EditPost = (props) => {
    const classes = useStyles();
    const [persian, setPersian] = useState(true);
    const [arabic, setArabic] = useState(false);
    const [svCategory, setSvCategory] = useState([]);
    const [loadingBtn, setLoadingBtn] = useState(false);
    const [loadings, setLoadings] = useState({
        load1: false,
        load2: false,
        load3: false,
    });
    const [alert, setAlert] = useState({
        open: false,
        type: "success",
        message: "",
    });
    const [editorState, setEditorState] = useState(EditorState.createEmpty());

    const adminArticleDetail = useSelector((state) => state.adminArticleDetail);

    const {
        loading,
        error,
        id,
        imgURL,
        categoryId,
        title,
        arTitle,
        shortDescription,
        arShortDescription,
        text,
        arText,
    } = adminArticleDetail;

    useEffect(() => {
        if (text) {
            const blocksFromHtml = htmlToDraft(text);
            const { contentBlocks, entityMap } = blocksFromHtml;
            const contentState = ContentState.createFromBlockArray(
                contentBlocks,
                entityMap
            );
            setEditorState(EditorState.createWithContent(contentState));
        }
    }, [text]);

    const TogglePersian = () => {
        setArabic(false);
        setPersian(true);
    };

    const ToggleArabic = () => {
        setPersian(false);
        setArabic(true);
    };

    const dispatch = useDispatch();

    const toggleCloseAlert = () => {
        setAlert({ open: false, type: alert.type, message: alert.message });
    };

    const toggleOpenAlert = (Type, msg) => {
        setAlert({
            open: true,
            type: Type,
            message: msg,
        });
    };

    useEffect(() => {

        const getCats = async () => {
            setLoadings({
                load1: true,
                load2: false,
                load3: false,
            });
            const config = {
                headers: {
                    Authorization: `Bearer ` + localStorage.getItem("token"),
                    "Content-Type": "application/json",
                },
            };
            try {
                const { data } = await axios.get(
                    "/api/admin/articles/getcategories",
                    config
                );
                if (data.status === "ok") {
                    cat = data.data;
                    setSvCategory(cat);
                    setLoadings({
                        load1: false,
                        load2: false,
                        load3: false,
                    });
                }
            } catch (e) {
                console.log(e);
                setLoadings({
                    load1: false,
                    load2: false,
                    load3: false,
                });
            }
        };

        getCats();

    }, []);

    useEffect(() => {

        dispatch(adminArticleDetailAction(props.id));

    }, []);

    const updateArticle = async (datas) => {

        setLoadingBtn(true);

        try {
            const { data } = await axios.post(`/api/admin/articles/update`, datas, {
                headers: {
                    Authorization: `Bearer ` + localStorage.getItem("token"),
                    "content-type": "multipart/form-data",
                },
            });
            if (data.status === "ok") {
                toggleOpenAlert("success", "مقاله با موفقیت ویرایش شد");
                setLoadingBtn(false);
                setTimeout(() => {
                    props.onBack(false, null);
                    dispatch({ type: ADMIN_ARTICEL_REQUEST_RESET });
                    window.scrollTo(0, 0)
                }, 2000);
            } else {
                toggleOpenAlert("error", "ویرایش مقاله با خطا مواجه شده است");
                setLoadingBtn(false);
            }
        } catch (error) {
            console.error(error);
            toggleOpenAlert("error", "خطا در ارتباط با سرور");
            setLoadingBtn(false);
        }
    };

    return (
        <Box pt={4} pb={2} px={1}>
            {loading && (
                <Box
                    display="flex"
                    justifyContent="center"
                    height="60vh"
                    alignItems="center"
                    textAlign="center">
                    <CircularProgress size={60} />
                </Box>
            )}

            {!loading && (
                <Formik
                    style={{ width: "100%" }}
                    initialValues={{
                        Image: "",
                        CategoryId: categoryId,
                        Title: title,
                        ShortDescription: shortDescription,
                        ArTitle: arTitle,
                        ArShortDescription: arShortDescription,
                        ArText: arText,
                    }}
                    onSubmit={(values) => {
                        if (
                            draftToHtml(convertToRaw(editorState.getCurrentContent()))
                                .length > 8
                        ) {
                            setLoadingBtn(true);
                            const editor = draftToHtml(
                                convertToRaw(editorState.getCurrentContent())
                            ).toString();
                            let formData = new FormData();
                            Object.keys(values).forEach(function eachKey(key) {
                                formData.append(key, values[key]);
                            });
                            formData.append("ArticleId", id);
                            formData.append("Text", editor);
                            updateArticle(formData);
                        }
                        else {
                            toggleOpenAlert("error", "لطفا متن اصلی را کامل وارد نمایید.");


                        }
                    }}
                    validationSchema={validationSchema}
                    render={({
                        handleSubmit,
                        handleChange,
                        handleBlur,
                        values,
                        touched,
                        errors,
                        setFieldValue,
                    }) => (
                        <form onSubmit={handleSubmit}>

                            <Grid container>
                                <Grid item xs={4}>
                                    <Box m={2} mt={0}>
                                        <FormControl
                                            error={touched.CategoryId && Boolean(errors.CategoryId)}
                                            fullWidth
                                            variant="outlined"
                                        >
                                            <InputLabel id="demo-simple-select-outlined-label">
                                                {loadings.load1 ? (
                                                    <CircularProgress size={12} />
                                                ) : (
                                                    "دسته بندی"
                                                )}
                                            </InputLabel>
                                            <Select
                                                fullWidth
                                                name="CategoryId"
                                                labelId="demo-simple-select-outlined-label"
                                                id="demo-simple-select-outlined"
                                                onChange={(e) => {
                                                    handleChange(e);
                                                }}
                                                label={
                                                    loadings.load1 ? (
                                                        <CircularProgress size={12} />
                                                    ) : (
                                                        "دسته بندی"
                                                    )
                                                }
                                                value={values.CategoryId}
                                            >
                                                <MenuItem disabled value="">
                                                    <em> انتخاب کنید</em>
                                                </MenuItem>
                                                {svCategory.length > 0 &&
                                                    svCategory.map((item) => (
                                                        <MenuItem value={item.id.toString()}>
                                                            {item.title}
                                                        </MenuItem>
                                                    ))}
                                            </Select>
                                        </FormControl>
                                    </Box>
                                </Grid>
                                <Grid xs={8}>
                                    <Box
                                        display="flex"
                                        mt={1}
                                        justifyContent="right"
                                        width="100%"
                                        mb={2}
                                    >
                                        <a
                                            className={classes.cursor}
                                            onClick={() => props.onBack(false, null)}
                                        >
                                            <Box
                                                bgcolor="#d4d4d4"
                                                fontWeight="bold"
                                                mr={-1}
                                                pl={0.8}
                                                borderRadius="5px 0px 0px 5px"
                                            >
                                                بازگشت
                    <ArrowBackIcon style={{ marginBottom: "-8px" }} />
                                            </Box>
                                        </a>
                                    </Box>
                                </Grid>
                            </Grid>
                            <Grid container>
                                <Grid item md={3}>
                                    <Box m={2}>
                                        <Field
                                            id="Image"
                                            name="Image"
                                            component={CustomImageInput}
                                            type="image"
                                            noBtn={true}
                                            defaultImage={imgURL}
                                            boxHeight="228px"
                                            setFieldValue={setFieldValue}
                                            errorMessage={errors.Image ? errors.Image : undefined}
                                            touched={touched.Image}
                                            style={{ display: "flex" }}
                                            onBlur={handleBlur}
                                        />
                                    </Box>
                                </Grid>
                                <Grid item md={9}>
                                    <Box>
                                        <Button
                                            className={persian ? classes.btnActive : classes.btn}
                                            onClick={TogglePersian}
                                        >
                                            محتوای فارسی
                    </Button>
                                        <Button
                                            className={arabic ? classes.btnActive : classes.btn}
                                            onClick={ToggleArabic}
                                        >
                                            محتوای عربی
                    </Button>
                                    </Box>
                                    <Box
                                        className={persian ? classes.show : classes.hide}
                                        pt={3}
                                        pb={3}
                                        bgcolor="#fff"
                                    >
                                        <Grid container>
                                            <Grid item md={12}>
                                                <Box px={3}>
                                                    <lable className={classes.label}>عنوان مقاله</lable>
                                                    <TextField
                                                        fullWidth
                                                        name="Title"
                                                        variant="outlined"
                                                        value={values.Title}
                                                        onChange={handleChange}
                                                        error={touched.Title && Boolean(errors.Title)}
                                                        helperText={touched.Title && errors.Title}
                                                    />
                                                </Box>
                                                <Box px={3} mt={1}>
                                                    <lable className={classes.label}>چکیده مقاله</lable>
                                                    <TextField
                                                        multiline
                                                        rows={11}
                                                        fullWidth
                                                        name="ShortDescription"
                                                        variant="outlined"
                                                        value={values.ShortDescription}
                                                        onChange={handleChange}
                                                        placeholder="چکیده مقاله"
                                                        error={
                                                            touched.ShortDescription &&
                                                            Boolean(errors.ShortDescription)
                                                        }
                                                        helperText={
                                                            touched.ShortDescription &&
                                                            errors.ShortDescription
                                                        }
                                                    />
                                                </Box>
                                                <Box px={3} mt={1}>
                                                    <lable className={classes.label}>
                                                        متن کامل مقاله
                          </lable>
                                                    <Editor
                                                        editorState={editorState}
                                                        onEditorStateChange={(value) =>
                                                            setEditorState(value)
                                                        }
                                                        wrapperClassName="demo-wrapper"
                                                        editorClassName="demo-editor"
                                                        textAlignment="right"
                                                        toolbar={{
                                                            inline: { inDropdown: true },
                                                            list: { inDropdown: true },
                                                            textAlign: { inDropdown: true },
                                                            link: { inDropdown: true },
                                                            history: { inDropdown: true },
                                                            image: {
                                                                alt: { present: true, mandatory: true },
                                                            },
                                                        }}
                                                    />
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </Box>

                                    <Box
                                        pt={3}
                                        pb={3}
                                        className={arabic ? classes.show : classes.hide}
                                        bgcolor="#fff"
                                    >
                                        <Grid container>
                                            <Grid item md={12}>
                                                <Box px={3}>
                                                    <lable className={classes.label}>
                                                        عنوان مقاله(به عربی)
                          </lable>
                                                    <TextField
                                                        fullWidth
                                                        name="ArTitle"
                                                        variant="outlined"
                                                        value={values.ArTitle}
                                                        onChange={handleChange}
                                                        error={touched.ArTitle && Boolean(errors.ArTitle)}
                                                        helperText={touched.ArTitle && errors.ArTitle}
                                                    />
                                                </Box>
                                                <Box px={3} mt={1}>
                                                    <lable className={classes.label}>
                                                        چکیده مقاله(به عربی)
                          </lable>
                                                    <TextField
                                                        multiline
                                                        rows={11}
                                                        fullWidth
                                                        name="ArShortDescription"
                                                        variant="outlined"
                                                        value={values.ArShortDescription}
                                                        onChange={handleChange}
                                                        placeholder="چکیده مقاله"
                                                        error={
                                                            touched.ArShortDescription &&
                                                            Boolean(errors.ArShortDescription)
                                                        }
                                                        helperText={
                                                            touched.ArShortDescription &&
                                                            errors.ArShortDescription
                                                        }
                                                    />
                                                </Box>
                                                <Box px={3} mt={1}>
                                                    <lable className={classes.label}>
                                                        متن کامل مقاله (به عربی)
                          </lable>
                                                    <TextField
                                                        multiline
                                                        rows={13}
                                                        fullWidth
                                                        name="ArText"
                                                        variant="outlined"
                                                        value={values.ArText}
                                                        onChange={handleChange}
                                                        placeholder="چکیده مقاله"
                                                        error={touched.ArText && Boolean(errors.ArText)}
                                                        helperText={touched.ArText && errors.ArText}
                                                    />
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </Grid>
                            </Grid>
                            <br />
                            <Box display="flex">
                                <Button
                                    disabled={loadingBtn}
                                    color="secondary"
                                    variant="contained"
                                    fullWidth
                                    type="submit"
                                >
                                    {!loadingBtn ? (
                                        "بروزرسانی تغییرات"
                                    ) : (
                                        <CircularProgress size={25} color="inherit" />
                                    )}
                                </Button>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <Button
                                    onClick={() => {
                                        props.onBack(false, null);
                                        dispatch({ type: ADMIN_ARTICEL_REQUEST_RESET });
                                    }}
                                    color="primary"
                                    variant="contained"
                                    fullWidth
                                >
                                    بازگشت
                </Button>
                            </Box>
                        </form>
                    )}
                />
            )}

            <Snackbar
                open={alert.open}
                autoHideDuration={4000}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                onClose={toggleCloseAlert}
            >
                <Alert onClose={toggleCloseAlert} severity={alert.type}>
                    {alert.message}
                </Alert>
            </Snackbar>
        </Box>
    );
};

export default EditPost;
